import React from 'react';
import { GiftIcon, GlassesIcon, StickerIcon, TicketIcon, ShirtIcon } from 'lucide-react';
import { Product } from '../../types/content';
type ProductImageProps = {
  product: Product;
  className?: string;
  fit?: 'cover' | 'contain';
};
const kindIcon = {
  apparel: ShirtIcon,
  deposit: TicketIcon,
  gift: GiftIcon,
  sticker: StickerIcon,
  inhouse: GlassesIcon
};
export function ProductImage({
  product,
  className = '',
  fit = 'cover'
}: ProductImageProps) {
  if (product.image) {
    return <img src={product.image} alt={product.name} loading="lazy" className={`h-full w-full ${fit === 'contain' ? 'object-contain' : 'object-cover'} ${className}`} data-id="element-225" data-mp="2rp7by9celtz1" />;
  }
  const Icon = kindIcon[product.kind];
  return <div className={`flex h-full w-full flex-col items-center justify-center gap-4 border border-ink-line bg-ink-surface p-6 text-center ${className}`} data-id="element-226" data-mp="240fn9ry0vtr0">
      <Icon className="h-14 w-14" strokeWidth={1} aria-hidden="true" data-id="element-227" data-mp="28y7pbesdsw8x" />
      <span className="font-slab text-xs font-bold uppercase tracking-[0.25em] text-ink-muted" data-id="element-228" data-mp="177wdx0tosza">Trip Ink Tattoo Co.</span>
    </div>;
}